import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ApiCallsService {
  constructor() {}
  //public domain: string = "https://api.mcredpro.com/";
 public domain: string = "https://api.mcredpro.com/";
 //public domain: string = "http://localhost:49808/";


   public getOrderTracking = this.domain + "api/user/getOrderTracking";
 //public login: string = this.domain + "api/superadmin/login";
 public login: string = this.domain + "api/register/login";
 public forgetpassword = this.domain + "api/superadmin/forgetpassword";
 public SetPassword = this.domain + "api/superadmin/SetPassword";
  //// Categories
  public CategoriesList: string = this.domain + "api/superadmin/Categories";
  public addcategory: string = this.domain + "api/superadmin/CreateCategories";
  public addSubCategories: string =
    this.domain + "api/superadmin/subCategoriescreation";
  public deleteCategories: string =
    this.domain + "api/superadmin/deleteCategories";
  public categoryimagefileupload: string =
    this.domain + "api/superadmin/categoryimagefileupload";
  public multiplecategoryimagefileupload: string =
    this.domain + "api/superadmin/categorymultipleimagefileuploads";
  public SubCategories: string = this.domain + "api/superadmin/SubCategories";
  public getMultipleimages: string =
    this.domain + "api/superadmin/getcategoryimages";
  public deletecategoryMultipleimage: string =
    this.domain + "api/superadmin/deletecategoryimage";
    public desigerSales: string =
    this.domain + "api/superadmin/getDesigerwiseSalesAnalytics";
    public desigerPowise: string =
    this.domain + "api/superadmin/getOrderProductAnalytics";
  // <!---------------- Products   ------------>

  /// General
  public getproducts: string = this.domain + "api/superadmin/getproducts";
  public createproduct: string = this.domain + "api/superadmin/createproduct";
  public getproduct: string = this.domain + "api/superadmin/getproduct";
  public deleteproduct: string = this.domain + "api/superadmin/deleteproduct";
  public createproductinsinglerequest: string =
    this.domain + "api/superadmin/createproductinsinglerequest";
  public getproductsinsinglerequest: string =
    this.domain + "api/superadmin/getproductsinsinglerequest";

  /// Data
  public createproductdata: string =
    this.domain + "api/superadmin/createproductdata";
  public getproductdata: string = this.domain + "api/superadmin/getproductdata";

  ////  Product Categories

  public createproductcategories: string =
    this.domain + "api/superadmin/createproductcategories";
  public getproductcategories: string =
    this.domain + "api/superadmin/getproductcategories";
  public deleteproductcategory: string =
    this.domain + "api/superadmin/deleteproductcategory";

  /////  Related Products

  public getrelatedproducts: string =
    this.domain + "api/superadmin/getrelatedproducts";
  public deleterelatedproduct: string =
    this.domain + "api/superadmin/deleterelatedproduct";
  public addrelatedproducttoproduct: string =
    this.domain + "api/superadmin/addrelatedproducttoproduct";

  // Product Images

  public productimagesfileuploads: string =
    this.domain + "api/superadmin/productimagesfileuploads";
  public getproductimages: string =
    this.domain + "api/superadmin/getproductimages";
  public deleteproductimage: string =
    this.domain + "api/superadmin/deleteproductimage";

  /// Product Discount

  public createproductdiscount: string =
    this.domain + "api/superadmin/createproductdiscount";
  public getproductdiscount: string =
    this.domain + "api/superadmin/getproductdiscount";

  // Sizes

  public getsizesforgender = this.domain + "api/superadmin/getsizesforgender";
  public getsizesforgender1 = this.domain + "api/user/GetproductsForCategory";
  public createsizes = this.domain + "api/superadmin/createsizes";
  public changeSizeStatus = this.domain + "api/superadmin/changeSizeStatus";
  public getsizes = this.domain + "api/superadmin/getsizes";

  // Colors
  public getcolors = this.domain + "api/superadmin/getcolors";
  public createcolor = this.domain + "api/superadmin/createcolor";
  public changColorStatus = this.domain + "api/superadmin/changColorStatus";

  /// Designers
  public designer = this.domain + "api/superadmin/designer";
  public getdesigners = this.domain + "api/superadmin/getdesigners";
  public changeDesignerStatus =
    this.domain + "api/superadmin/changeDesignerStatus";

  // Coupons

  public getcoupons = this.domain + "api/superadmin/getcoupons";
  public AddEditCoupon = this.domain + "api/superadmin/AddEditCoupon";

  // Design requests
  public getdesignrequests = this.domain + "api/superadmin/getdesignrequests";

  // Orders orders
  public orders = this.domain + "api/superadmin/orders";
  public returnOrders = this.domain + "api/superadmin/returnorders";
  public getOrderProductDetails =
    this.domain + "api/superadmin/getOrderProductDetails";
  public getTransactions = this.domain + "api/superadmin/getTransactions";
  public getCustomers = this.domain + "api/superadmin/getCustomers";
  public changeUserStatus = this.domain + "api/superadmin/changeUserStatus";
  public resetPassword = this.domain + "api/superadmin/resetPassword";
  public getOrderTransactions =
    this.domain + "api/superadmin/getOrderTransactions";
  public updateTransationStatus =
    this.domain + "api/superadmin/updateTransactionStatus";
  public getReviewsRatings = this.domain + "api/superadmin/getReviewsRatings";
  public saveReviewReplay = this.domain + "api/superadmin/saveReviewReplay";
  public changeProductReviewStatus =
    this.domain + "api/superadmin/changeProductReviewStatus";
  public getProductLikes = this.domain + "api/superadmin/get-product-likes";
  public getPricesForFilter = this.domain + "api/superadmin/getPricesForFilter";
  public saveFilterPrice = this.domain + "api/superadmin/save-filter-price";
  public deleteFilterPrice = this.domain + "api/superadmin/delete-filter-price";
  public getMeterials = this.domain + 'api/superadmin/getallmaterials';
  public saveMaterial = this.domain + 'api/superadmin/savematerial';
  public changeMaterialStatus = this.domain + 'api/superadmin/changematerialstatus';
  public changePriceStatus = this.domain + "api/superadmin/changePriceStatus";
  public getDashboardCounts = this.domain + "api/superadmin/dashboard-counts";
  public getDashboardAnalytics =
    this.domain + "api/superadmin/getDashboardAnalytics";
    public getsalesAnalytics =
    this.domain + "api/superadmin/getSalesAnalytics";
  public getTopOrders = this.domain + "api/superadmin/getTopOrders";
  public getDesignersProductCount =
    this.domain + "api/superadmin/getDesignersProductCount";
  public getProductsForDesigner: string =
    this.domain + "api/user/productsForDesigner";
  public getMonthWiseSales: string =
    this.domain + "api/superadmin/getMonthWiseSales";
  public getYearWiseSales: string =
    this.domain + "api/superadmin/getYearWiseSales";
    public getDesignerWiseSales: string = this.domain + 'api/superadmin/getDesignerWiseSales';
    public getCategoryWiseSales: string = this.domain + 'api/superadmin/getCategoryWiseSales';
    public getAllGraphDataByCustomDate: string = this.domain + 'api/superadmin/GetAllGraphDataByCustomDate';
    public getDesignerGraphDataByCustomDate: string = this.domain + 'api/superadmin/GetDesignerGraphDataByCustomDate';

    public getAllDeliveryLocation =this.domain + "api/superadmin/GetAllDeliveryLocation";
    public getDefaultAllDeliveryLocationData =this.domain + "api/superadmin/GetDefaultAllDeliveryLocationData";
    public changeDeliveryLocationStatus =this.domain + "api/superadmin/ChangeDeliveryLocationStatus";


    public getDeliveryLocationByID =this.domain + "api/superadmin/GetDeliveryLocationByID";
    public getAllCountrys =this.domain + "api/superadmin/GetAllCountrys";
    public getStatesByCountryID =this.domain + "api/superadmin/GetStatesByCountryID";
    public getCitiesByStateID =this.domain + "api/superadmin/GetCitiesByStateID";
    public addDeliveryLocation =this.domain + "api/superadmin/AddDeliveryLocation";
    public updateDeliveryLocation =this.domain + "api/superadmin/UpdateDeliveryLocation";
    public getDelivaryStatusCodes =this.domain + "api/superadmin/GetDelivaryStatusCodes";


    public getAllDeliverySlot =this.domain + "api/superadmin/GetAllDeliverySlot";
    public changeDeliverySlotStatus =this.domain + "api/superadmin/ChangeDeliverySlotStatus";
    public getDeliverySlotByID =this.domain + "api/superadmin/GetDeliverySlotByID";
    public addDeliverySlot =this.domain + "api/superadmin/AddDeliverySlot";
    public updateDeliverySlot =this.domain + "api/superadmin/UpdateDeliverySlot";    

    public getDelivaryAgentsByLocation =this.domain + "api/superadmin/GetDelivaryAgentsByLocation"; 
    public getAssignedOrderByID =this.domain + "api/superadmin/GetAssignedOrderByID"; 

    
    //Delivery Agent
    public getAllDeliveryAgents =this.domain + "api/superadmin/GetAllDeliveryAgents"; 
    public changeDeliveryAgentStatus =this.domain + "api/superadmin/ChangeDeliveryAgentStatus";
    public getDeliveryAgentByID =this.domain + "api/superadmin/GetDeliveryAgentByID";
    public getDelivaryLocationFilterData =this.domain + "api/superadmin/GetDelivaryLocationFilterData";
    public addDeliveryAgent =this.domain + "api/superadmin/AddDeliveryAgent";
    public updateDeliveryAgent =this.domain + "api/superadmin/UpdateDeliveryAgent";
    public removeDeliveryAgentDocuments =this.domain + "api/superadmin/RemoveDeliveryAgentDocuments";
    public assignOrderToDeliveryAgent =this.domain + "api/superadmin/AssignOrderToDeliveryAgent";
    public updateAssignedOrder =this.domain + "api/superadmin/UpdateAssignedOrder";

    
    // return
    public getReturnOrderTracking = this.domain + "api/superadmin/GetReturnOrderTracking";
    public getReturnOrderProductDetails = this.domain + "api/superadmin/getReturnOrderProductDetails";
    public getReturnStatus = this.domain + "api/superadmin/getReturnStatus";
    public updateReturnTransactionStatus = this.domain + "api/superadmin/UpdateReturnTransactionStatus";

    //Brand/Designer
    public addOrUpdateDesigner = this.domain + "api/superadmin/Designer";
    public getDesignerDataById = this.domain + "api/superadmin/getdesigners";
    public removeDesignerID = this.domain + "api/superadmin/RemoveDesignerID";
    public getAllTopLevelFilterData = this.domain + "api/superadmin/GetAllTopLevelFilterData";
    public getAllChildLevelFilterData = this.domain + "api/superadmin/GetAllChildLevelFilterData";
    public getAllActiveGenders = this.domain + "api/superadmin/GetAllActiveGenders";
    public addSizes = this.domain + "api/superadmin/AddSizes";
    public getCountryPhoneCode = this.domain + "api/superadmin/GetCountryPhoneCode";
    public updateProductStatus = this.domain + "api/superadmin/UpdateProductStatus";


    public getCustomerDetailByUserId = this.domain + "api/superadmin/GetCustomerDetailByUserId";
    public updateCustomerStatus = this.domain + "api/superadmin/UpdateCustomerStatus";

    
    
}
